import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { useCurrentCase } from "duck";
import { Comment } from "./components";
import { CommentLocation } from "./duck";

interface CommentsProps {
  enabled: boolean;
  children: React.ReactNode;
}

const Comments: React.FC<CommentsProps> = ({ enabled, children }) => {
  const [newComments, setNewComments] = useState<CommentLocation[]>([]);
  const dentalSketchComments = useCurrentCase(
    ({ data }) => data.client.patient.dentalSketchComments
  );

  const clickHandler = (e: React.MouseEvent) => {
    if (!enabled) {
      return;
    }
    const { offsetX, offsetY } = e.nativeEvent;
    const { height, width } = e.target as HTMLCanvasElement;

    setNewComments(prev => [
      ...prev,
      {
        x: (offsetX / width) * 100,
        y: ((offsetY - 40) / height) * 100
      }
    ]);
  };

  return (
    <Box w="100%" position="relative" onClick={clickHandler}>
      {children}
      {dentalSketchComments.map(({ locationX, locationY, ...comment }) => (
        <Comment
          key={comment._id || comment.fakeId}
          comment={comment}
          location={{
            x: locationX,
            y: locationY
          }}
        />
      ))}
      {newComments.map((location, i) => (
        <Comment
          key={i}
          isNew
          location={location}
          onSave={() => setNewComments([])}
        />
      ))}
    </Box>
  );
};

export default Comments;
